import type {Theme} from '../theme';
import {createBaseThemeVariation} from './base';

export const BigBenKidsTheme: Theme = createBaseThemeVariation({
    name: 'bigbenkids',
    brandColor: 'hsla(229, 40%, 25%, 1)',
    primaryColors: {
        p50: 'hsla(229, 40%, 97%, 1)',
        p75: 'hsla(229, 40%, 95%, 1)',
        p100: 'hsla(229, 40%, 92%, 1)',
        p200: 'hsla(229, 40%, 75%, 1)',
        p300: 'hsla(229, 40%, 45%, 1)',
        p400: 'hsla(229, 40%, 25%, 1)',
        p500: 'hsla(229, 40%, 14%, 1)',
    },
});
